var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJapan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37V22H0V0Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_697",
    transform: "scale(0.00675676 0.0113636)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_697",
    width: 148,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAABYBAMAAADhOMMoAAAAHlBMVEVHcEzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzmEFSSAAAACHRSTlMAQIPQFfBoMLvDO4kAAAEoSURBVFjD7dk9CsJAEAXg/GHa6AliunQpREgXEARPIOkEbezSeJHECN5WUERNdoIz+1KIMwf4muy+mdk4V1g5f0BNIXWnHEgppZRSY1HhLEnmFYAK9o8IWRa21Dp/xlFzsKO88hVtbWxDufl7TDaRBZV+Rm4tp1bd+F5IqbDsUm0lpE79rrKVUUHZp9pCRPmmZpeJqNRE1RLKNffgSED5ZioTUKmZqvmU6fsNfcMBakINLDs25VNUxqY2FHVmU0eKurCpnKIaNjUwKDKpkKYqJuXSVMSkPJqKlfoFCngYgEcUeHGQ1xkYMsDoAwYysE0AmxewpSIbPXD8AA5FyFENOEACx1rksA1cAZCLCXJdAi5xyNUSufAi13B9/VBKqbEp4CO5/pv4sm5T17yvAWPkqwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/japan.c581b51ab8f4b4a11d050f706b507f45.svg";
export { ForwardRef as ReactComponent };